import { render } from "./ProductComparisonTable.vue?vue&type=template&id=5b88a1c4"
import script from "./ProductComparisonTable.vue?vue&type=script&lang=js"
export * from "./ProductComparisonTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__